@use 'styles/utils/variables' as *;

// Same shapes as the mobile Skeleton: border-tone blocks (they read on the page and on a card in
// both themes), small radius, a slow pulse down to 45% opacity and back.
@keyframes skeletonPulse {
  to {
    opacity: var(--skeletonPulseOpacity);
  }
}

.skeleton {
  @media (prefers-reduced-motion: no-preference) {
    animation: skeletonPulse var(--skeletonPulseDuration) $ease-in-out infinite alternate;
  }
}

.block {
  display: block;
  width: 100%;
  height: 1.2rem;
  border-radius: $radius-sm;
  background-color: var(--border);
}

// Read by screen readers, not drawn
.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}
